import './AxisTickWithTruncation.css';
export var directionValue = 'var(--_z2zz8y0-3-5-0)';
export var tickStyle = '_z2zz8y2-3-5-0';
export var widthContainer = 'var(--_z2zz8y1-3-5-0)';